import React from 'react';
import { useSelector } from 'react-redux';
import { useScrollToAnchor } from '../../../../../hooks/uaeScrollToAnchor';
import { getClassLabelKey, isCharedi } from '../../../../../utils/utils';
import { getCharacterImagePath } from '../../../../../ui/builders/utils';
import studentImg from '../../../../../assets/scoreboard/studentCardImg.png';
import classes from './StudentInfo.module.css';

const StudentInfo = () => {
    const { texts } = useSelector((state) => state.translate);
    const { user, school } = useSelector((state) => state.auth);
    const { characterRank } = useSelector((state) => state.contest.achievements);
    const scrollToAnchor = useScrollToAnchor();
    const characterImageUrl = getCharacterImagePath(characterRank);

    return (
        <div className={classes.studentInfo}>
            {isCharedi() ? 
            <img src={studentImg} className={classes.studentImage} alt="תלמיד" />
            :
            <img src={characterImageUrl} className={classes.characterImage} onClick={() => scrollToAnchor('characters-block')} alt="דמות מדען" /> 
            }
            <div className={classes.textContainer}>
                {user?.name && <p className={classes.boldText}>{user?.name}</p>}
                <p className={classes.text}>{` ${user?.studentkita ? `${texts.class} ${texts[getClassLabelKey(user?.studentkita)]}'${user?.studentmakbila} •` : ''} ${school?.name ? ` ${texts.school} ${school?.name}` : ''}`}</p>
            </div>
        </div>
    );
};

export default StudentInfo;

